var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaintenance = function SvgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15300_78321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 10.4387C6.28516 9.0216 7.07246 7.78914 8.23187 7.1582V8.76184C8.23187 9.74176 9.02305 10.5361 9.99902 10.5361C10.975 10.5361 11.7588 9.74176 11.7588 8.76184V7.1582C12.9011 7.77984 13.6896 8.98543 13.7124 10.3762C13.7358 11.8074 12.9821 13.075 11.7588 13.7189V18.9741H8.23191V13.7232C7.02496 13.0935 6.28516 11.8588 6.28516 10.4387Z",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 7.17618L8.62137 1.47372C9.44324 0.875947 10.5567 0.875947 11.3786 1.47372L19.2188 7.17618",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 6.30664V16.6308C2.24609 17.9252 3.29543 18.9745 4.58984 18.9745H15.4112C16.7056 18.9745 17.7549 17.9252 17.7549 16.6308V16.6245",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 12.7196V3.71094",
    stroke: "#EEF1F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15300_78321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgMaintenance;